import { useMemo } from 'react';

import { useReviewCreationV1Data, REVIEW_PROVIDER_TYPE_LABELS_V1 } from 'reducers/reviewCreationV1Slice';
import { checkEnableReviewWithoutSelfReview } from 'utils/helpers/featureFlags';

import { REVIEW_PROVIDER_TYPES } from 'constants/ProjectConstants';

import { SearchableAgGridMenu } from 'uiToolkitV1/SearchableAgGridMenu/SearchableAgGridMenu';

import { useUpdateEnabledProviderTypes } from '../../dataHooks/formsSectionHooks';

export const providerTypeOptions = Object.keys(REVIEW_PROVIDER_TYPES).map((providerType) => ({
  id: providerType,
  title: REVIEW_PROVIDER_TYPE_LABELS_V1[providerType],
}));

export const FormsSelector = () => {
  const { enabledProviderTypes } = useReviewCreationV1Data();
  const { mutate: updateProviderTypes } = useUpdateEnabledProviderTypes();
  const isReviewWithoutMandatorySelfReviewEnabled = checkEnableReviewWithoutSelfReview();

  const defaultCheckedRows = useMemo(
    () => providerTypeOptions.filter(({ id }) => enabledProviderTypes.includes(id)),
    [enabledProviderTypes]
  );

  const onProviderTypeSelectHandler = (checkedRows) => {
    updateProviderTypes({ enabledProviderTypes: checkedRows.map((row) => row.id) });
  };

  const gridOptions = useMemo(
    () => ({
      // Events to prevent selection changes
      onRowClicked: (event) => {
        const { id } = event.data;

        if ([REVIEW_PROVIDER_TYPES.MANAGER, REVIEW_PROVIDER_TYPES.SELF].includes(id)) {
          event.node.setSelected(true);
        }
      },
      rowClassRules: {
        'ag-row-disabled-review-creation': ({ data }) => {
          if (isReviewWithoutMandatorySelfReviewEnabled) {
            return [REVIEW_PROVIDER_TYPES.MANAGER].includes(data.id);
          }
          return [REVIEW_PROVIDER_TYPES.MANAGER, REVIEW_PROVIDER_TYPES.SELF].includes(data.id);
        },
      },
    }),
    [isReviewWithoutMandatorySelfReviewEnabled]
  );

  return (
    <SearchableAgGridMenu
      rowData={providerTypeOptions}
      onApply={onProviderTypeSelectHandler}
      defaultCheckedRows={defaultCheckedRows}
      key={defaultCheckedRows.length}
      gridOptions={gridOptions}
      showSearchInput={false}
      optionsHeight="212px"
      placeholder="Select Reviewers"
    />
  );
};
